module.exports = __webpack_public_path__ + "static/media/gcdef_10010.2b9de737.ico";